export enum ChatSessionsKeys {
    sessions = 'sessions'
}